<template>
    <div>
        <v-card elevation="0">
            <v-card-subtitle>
                Student Name: {{ student.firstname+" "+student.lastname }} <br />
                Student Number: {{ student.emplid }} <br />
                Student Email: {{ student.email }}
            </v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text v-if="!loading">
                <v-row>
                    <v-col cols="6">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" colspan="2">
                                            <v-icon small>mdi-file-chart</v-icon>&nbsp;Statements
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left">
                                            Year
                                        </th>
                                        <th class="text-left">
                                            File
                                        </th>
                                        <th class="text-left">
                                            Download
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="statements.length > 0">
                                    <tr
                                        v-for="file in statements"
                                        :key="file.year"
                                    >
                                        <td>{{ file.year }}</td>
                                        <td>{{ file.filename }}</td>
                                        <td><v-icon small @click="downloadFile(file.filename, 'statement')">mdi-download</v-icon></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3" class="text-center">No Statements</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="6">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" colspan="2">
                                            <v-icon small>mdi-file-table</v-icon>&nbsp;Net Bill
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left">
                                            Date Generated
                                        </th>
                                        <th class="text-left">
                                            View
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="shownetbill">
                                        <td>{{ netbill["generatedDate"] }}</td>
                                        <td>
                                            <v-dialog v-model="dialogNetBill" width="800" persistent> 
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" small>mdi-eye</v-icon>
                                                </template>
                                                <v-card>
                                                    <v-toolbar color="#8FB3A3" dark>
                                                        <v-toolbar-title style="color:white;">View Net Bill Data</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-btn icon @click="dialogNetBill = false">
                                                            <v-icon color="white">mdi-close-thick</v-icon>
                                                        </v-btn>
                                                    </v-toolbar>
                                                    <NetBillView :netbill="netbill" />
                                                </v-card>
                                            </v-dialog>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="2" class="text-center">{{ netbillerrortext }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" colspan="2">
                                            <v-icon small>mdi-file-export</v-icon>&nbsp;T4A
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left">
                                            Year
                                        </th>
                                        <th class="text-left">
                                            File
                                        </th>
                                        <th class="text-left">
                                            Download
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="t4a.length > 0">
                                    <tr
                                        v-for="file in t4a"
                                        :key="file.year"
                                    >
                                        <td>{{ file.year }}</td>
                                        <td>{{ file.filename }}</td>
                                        <td><v-icon small @click="downloadFile(file.filename, 'T4A')">mdi-download</v-icon></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3" class="text-center">No T4A Statement</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="6">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" colspan="2">
                                            <v-icon small>mdi-file-star</v-icon>&nbsp;T2202A
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-left">
                                            Year
                                        </th>
                                        <th class="text-left">
                                            File
                                        </th>
                                        <th class="text-left">
                                            Download
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="t2202a.length > 0">
                                    <tr
                                        v-for="file in t2202a"
                                        :key="file.year"
                                    >
                                        <td>{{ file.year }}</td>
                                        <td>{{ file.filename }}</td>
                                        <td><v-icon small @click="downloadFile(file.filename, 'T2202A')">mdi-download</v-icon></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3" class="text-center">No T2202A Statements</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text v-else>
                <v-row
                    class="fill-height"
                    align-content="center"
                    justify="center"
                >
                    <v-col
                        class="text-subtitle-1 text-center"
                        cols="12"
                    >
                        Getting files
                    </v-col>
                    <v-col cols="6">
                        <v-progress-linear
                            color="#BE977E"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import NetBillView from "./IndividualNetBill.vue"
export default {
    components: {
        NetBillView
    },
    props: {
        student: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            statements: [],
            netbill: [],
            t4a: [],
            t2202a: [],
            netbill: {},
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loading: true,
            dialogNetBill: false,
            shownetbill: false,
            netbillerrortext: ""
        }
    },
    methods:{
        getDocumentList(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?getdocuments&data={"emplid":"'+that.student.emplid+'"}';

            that.loading = true;
            that.statements = [];
            that.t4a = [];
            that.t2202a = [];
            that.netbill = {};

            fetch(api)
                .then(function(response){
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.setSnackbar("Successful: File(s) found", "green");
                        //Statements
                        var array_stat = data.data["statement"];
                        var keys_stat = Object.keys(array_stat);
                        if(keys_stat.length > 0){
                            for(var i=keys_stat.length-1;i>=0; i--){
                                for(var j=0;j<array_stat[keys_stat[i]].length; j++){
                                    that.statements.push({
                                        "year" : keys_stat[i],
                                        "filename" : array_stat[keys_stat[i]][j]
                                    });
                                }
                            }
                        }
                        //netbill
                        var netbilldata = data.data["netbill"]["CURRENT"][0];

                        if(Object.keys(netbilldata).length === 0){
                            that.shownetbill = false;
                            that.netbillerrortext = "No Net Bill data";
                        }else if(netbilldata.hasOwnProperty("error")){
                            that.shownetbill = false;
                            that.netbillerrortext = netbilldata["error"];
                        }else {
                            that.netbill = netbilldata;
                            that.shownetbill = true;
                        }
                        //t4a
                        var array_t4a = data.data["T4A"];
                        var keys_t4a = Object.keys(array_t4a);
                        if(keys_t4a.length > 0){
                            for(var i=keys_t4a.length-1;i>=0; i--){
                                for(var j=0;j<array_t4a[keys_t4a[i]].length; j++){
                                    that.t4a.push({
                                        "year" : keys_t4a[i],
                                        "filename" : array_t4a[keys_t4a[i]][j]
                                    });
                                }
                            }
                        }
                        //t2202a
                        var array_t2202a = data.data["T2202A"];
                        var keys_t2202a = Object.keys(array_t2202a);
                        if(keys_t2202a.length > 0){
                            for(var i=keys_t2202a.length-1;i>=0; i--){
                                for(var j=0;j<array_t2202a[keys_t2202a[i]].length; j++){
                                    that.t2202a.push({
                                        "year" : keys_t2202a[i],
                                        "filename" : array_t2202a[keys_t2202a[i]][j]
                                    });
                                }
                            }
                        }

                        that.loading = false;
                    }else {
                        that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error occurred : "+err.toString(), "red");
                })
        },
        downloadFile(filename, type){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?download&data={ "emplid" : "'+that.student.emplid+'", "file" : "'+filename+'", "type" : "'+type+'" }';

            fetch(api, {
                method: 'POST'
            })
            .then(function(response){
                return response;
            })
            .then(function(data){
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;

            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getDocumentList();
    }
}
</script>